// extracted by mini-css-extract-plugin
export default {"list":"ActiveFilterChips_list__H9iDz","item":"ActiveFilterChips_item__gyWLG","label":"ActiveFilterChips_label__PzGM9","remove":"ActiveFilterChips_remove__gnCZ-"};